import { getSavedSearchResultsKey } from './SavedSearchResultsReducer';
import * as actions from '../actions/SavedSearchColumnsActions';

const initialState = {};

function SavedSearchColumnsReducer(state = initialState, action) {
  const savedSearchKey = getSavedSearchResultsKey(action.entityName, action.savedSearchName);
  switch (action.type) {
    case actions.GET_SAVED_SEARCH_COLUMNS_SUCCESS: {
      return {
        ...state,
        [savedSearchKey]: {
          columns: action.columns,
          error: null,
        },
      };
    }
    default:
      return state;
  }
}

export default SavedSearchColumnsReducer;
